import { useEffect, useState } from 'react'
import type { Size } from '@/lib/types'
import { parseSizes, sizesToText } from '../lib/sizes'

export function Field({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <label className="flex flex-col gap-1 text-sm">
      <span className="text-[11px] uppercase tracking-wide text-slate-500">{label}</span>
      {children}
    </label>
  )
}

export function SizesInput({
  value,
  onChange,
}: {
  value: Size[]
  onChange: (next: Size[]) => void
}) {
  const [text, setText] = useState(() => sizesToText(value))
  const [err, setErr] = useState<string | null>(null)

  // Nadpisuj tekst tylko przy zmianie z zewnątrz (np. „Cofnij zmiany”). Po własnym commicie
  // tekst i value znaczą to samo — reset zjadałby wpisany przecinek/enter przed kolejnym rozmiarem.
  useEffect(() => {
    setText((prev) => {
      const parsed = parseSizes(prev)
      const same = !(parsed instanceof Error) && sizesToText(parsed) === sizesToText(value)
      return same ? prev : sizesToText(value)
    })
    setErr(null)
  }, [value])

  function commit(next: string) {
    setText(next)
    const parsed = parseSizes(next)
    if (parsed instanceof Error) {
      setErr(parsed.message)
      return
    }
    setErr(null)
    onChange(parsed)
  }
  return (
    <div>
      <textarea
        value={text}
        spellCheck={false}
        onChange={(e) => commit(e.target.value)}
        rows={Math.min(6, Math.max(2, Math.ceil(text.length / 60)))}
        placeholder="np. 300x250, 728x90"
        className="json-editor block w-full resize-y rounded border border-slate-200 bg-slate-50 p-2 outline-none focus:border-slate-400"
      />
      {err && <p className="mt-1 text-[11px] text-rose-600">{err}</p>}
    </div>
  )
}
